import http from "./utils";
import { prefix } from './constants';
import axios from 'axios';
const CancelToken = axios.CancelToken;
export const getHashtagChartDate: (
  payload: any,
  cancelCallback: () => void,
) => Promise<any> | any = (payload, cancelCallback) => {
  return http({
    url: `${prefix}/hashtag/timeline`,
    method: 'post',
    data: payload,
    cancelToken: new CancelToken(cancelCallback),
  }) as Promise<any>;
};

export const getHashtagTableDate: (payload: any) => Promise<any> | any = (
  payload,
) => {
  return http({
    url: `${prefix}/hashtag/list`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};
